export default function OffresConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('offres');
}

OffresConfiguration.$inject = ['$translatePartialLoaderProvider'];
